var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "default-box", style: { height: _vm.wrapHeight } },
    [
      _c(
        "el-table",
        {
          ref: "defaultTable",
          attrs: {
            id: "default-table",
            data: _vm.tableData,
            height: _vm.height,
            border: _vm.border,
            "cell-class-name": "cell-wrap white",
            "header-cell-class-name": "header-cell",
            "row-class-name": "row",
          },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _vm.selection
            ? _c("el-table-column", {
                attrs: {
                  selectable: _vm.selectable,
                  width: "68px",
                  type: "selection",
                  align: "center",
                  "header-align": "center",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.index
            ? _c("el-table-column", {
                attrs: {
                  label: "序号",
                  width: "80px",
                  type: "index",
                  align: "center",
                  "header-align": "center",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.columnData, function (column, index) {
            return _c("el-table-column", {
              key: column.prop + index,
              attrs: {
                prop: column.prop,
                label: column.label,
                width: column.width,
                "min-width": column.minWidth,
                formatter: (r, c, value) =>
                  _vm.getFormatter(r, c, value, column.formatter),
                "show-overflow-tooltip": column.overflow,
                "class-name": "handle",
                align: "center",
                "header-align": "center",
              },
            })
          }),
          _vm._v(" "),
          _vm.selector
            ? _c("el-table-column", {
                attrs: {
                  label: _vm.selector.title,
                  align: "center",
                  "header-align": "center",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-select",
                            {
                              ref: `${scope.row.id}-selector`,
                              attrs: {
                                loading: _vm.goodsLoading,
                                disabled: !scope.row.saleable,
                                size: "small",
                                remote: "",
                              },
                              on: {
                                "visible-change": function ($event) {
                                  return _vm.remoteGoodsMethod(
                                    arguments,
                                    scope.row
                                  )
                                },
                                change: function ($event) {
                                  return _vm.handleChangeSelector(scope.row)
                                },
                              },
                              model: {
                                value: scope.row[_vm.selector.field],
                                callback: function ($$v) {
                                  _vm.$set(scope.row, _vm.selector.field, $$v)
                                },
                                expression: "scope.row[selector.field]",
                              },
                            },
                            _vm._l(scope.row.goodsInfoList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.label, value: item.id },
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          scope.row.saleable && !scope.row.inUse
                            ? _c("p", [
                                _vm._v(
                                  "\n          商品规格信息发生改变，请重新选择\n        "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1600842113
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.radio
            ? _c("el-table-column", {
                attrs: {
                  label: _vm.radio.title,
                  align: "center",
                  "header-align": "center",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-switch", {
                            attrs: {
                              "active-color": "#13ce66",
                              "inactive-color": "#CCCCCC",
                            },
                            on: { change: _vm.handleChangeSwitch },
                            model: {
                              value: scope.row[_vm.radio.status],
                              callback: function ($$v) {
                                _vm.$set(scope.row, _vm.radio.status, $$v)
                              },
                              expression: "scope.row[radio.status]",
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3000667562
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.option
            ? _c("el-table-column", {
                staticClass: "option-wrap",
                attrs: {
                  width: _vm.opWidth,
                  label: "操作",
                  align: "center",
                  "header-align": "center",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "button-list" },
                            _vm._l(_vm.options, function (op, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "table-button" },
                                [
                                  _vm.isOptionShow(op, scope)
                                    ? _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "border-radius": "4px",
                                          },
                                          attrs: {
                                            loading:
                                              op.waiting &&
                                              Array.isArray(op.waiting)
                                                ? op.waiting.some(
                                                    (v) => v === scope.$index
                                                  )
                                                : false,
                                            disabled: !_vm.isOptionShow(
                                              op,
                                              scope
                                            ),
                                            type: "text",
                                          },
                                          on: {
                                            click: ($event) => {
                                              op.onclick(scope.row, op)
                                              _vm.clearButtonFocus($event)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(op.name) +
                                              "\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2064663265
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.optionDate
            ? _c("el-table-column", {
                staticClass: "option-wrap",
                attrs: {
                  width: _vm.opDateWidth,
                  label: "操作时间",
                  align: "center",
                  "header-align": "center",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm._f("formatTime")(
                                    scope.row[_vm.optionDateField]
                                  )
                                ) +
                                "\n        "
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  969137635
                ),
              })
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.pagination
        ? _c("el-pagination", {
            staticStyle: { "margin-right": "20px" },
            attrs: {
              "current-page": _vm.currentPage,
              "page-size": _vm.pageSize,
              total: _vm.total,
              layout: "total, sizes, prev, pager, next, jumper",
              background: "",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }